import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Typography, Box, useTheme } from "__barrel_optimize__?names=Box,Typography,useTheme!=!@mui/material";
import { tokens } from "../theme";
import { appStyled } from "../utilityFunctions";
const PageDescription = (props)=>{
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const Wrapper = appStyled(Box)((param)=>{
        let { theme, paddingBottom } = param;
        return {
            paddingTop: "43px",
            paddingBottom: paddingBottom || "30px",
            [theme.breakpoints.down("lg")]: {
                paddingTop: "35px",
                paddingBottom: "30px"
            },
            [theme.breakpoints.down("md")]: {
                paddingTop: "35px",
                paddingBottom: "15px"
            }
        };
    });
    return /*#__PURE__*/ _jsxs(Wrapper, {
        paddingBottom: props.paadingBottom,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h3",
                color: colors.text.main,
                children: props.title
            }),
            props.subtitle && /*#__PURE__*/ _jsx(Typography, {
                mt: "17px",
                variant: "h2",
                color: colors.text.main,
                children: props.subtitle
            })
        ]
    });
};
export default PageDescription;
